<template>
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-col lg="11" sm="8" xl="7">
        <v-card class="elevation-0">
          <v-row>
            
            <v-col lg="7" class="lime darken-3 d-none d-md-flex align-center justify-center">
              <div class="d-none d-sm-block">
                <div class="d-flex align-center pa-10">
                  <div>
                    <h4 class="display-1 white--text font-weight-medium">சார்லட் தமிழ்ச் சங்கம்</h4><br>
                    <h7 class="subtitle-1 mt-4 white--text op-5 font-weight-regular"> 
                     Charlotte Tamil Sangam works to bring together the vibrant Tamil community in the Charlotte area and strives to promote the Tamil language, arts and culture.
                    </h7>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col lg="5">
              <div class="text-center mt-3">
                  <img src="@/assets/cltts_logo.png" width="60"/>            
                <h3 class="font-weight-bold mt-4 blue-grey--text text--darken-2">SEND VERIFICATION EMAIL</h3><br>
              </div>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field v-model="email" height="22" outlined class="mt-4" :rules="emailRules" label="E-mail" placeholder=" " required></v-text-field>
                <v-btn @click="sendEmail()" class="caption mt-4" dark color="lime darken-3" block>Send Email</v-btn><br>
                <v-alert v-if="popupError" dense class="caption" outlined type="error">Enter valid Email Id</v-alert>
                <v-alert v-if="showMessage" outlined dense class="caption" type="success">Email sent.</v-alert>
              </v-form>

                <div class="text-center mt-6">
                  <a href="https://www.facebook.com/arasi.nagara.tamil.palli/" class><v-chip pill class="mr-2">
                    <v-avatar left>
                      <v-btn color="lime darken-3" class="white--text">
                        <v-icon>mdi-facebook</v-icon>
                      </v-btn>
                    </v-avatar>facebook                  
                  </v-chip>
                  </a>
                </div>

            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      valid: true,
      showMessage: false,
      popupError:  false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }),
    methods: {
      sendEmail() {
        if (!(this.email === null || this.email === '')) {
        this.$store.dispatch('sendVerifyEmail', this.email)
        setTimeout(() => {
            this.$router.replace('/Signin')
            this.showMessage= true
          }, 200)
          } else {
            this.popupError = true
        }
      },
    }
  }
</script>
